/** Popisky a CSS třídy stavů žádostí o nákup. */

export const PURCHASE_STATUS_LABELS: Record<string, string> = {
  pending_leader: 'Čeká na vedoucího',
  new: 'Nová',
  deferred: 'Odloženo ekonomem',
  approved_by_economist: 'Schváleno ekonomem',
  rejected: 'Zamítnuto',
  rejected_by_economist: 'Zamítnuto ekonomem',
  approved_by_director: 'Schváleno ředitelem',
  rejected_by_director: 'Zamítnuto ředitelem',
  rejected_by_vedouci: 'Zrušeno (staré)',
  rejected_by_leader: 'Zamítnuto vedoucím',
  cancelled_by_requester: 'Zrušeno žadatelem',
  cancelled_by_leader: 'Zrušeno vedoucím',
  rejected_by_referent: 'Zamítnuto obchodním referentem',
  accepted_by_referent: 'Přijato obchodním referentem',
  ordered_by_referent: 'Objednáno obchodním referentem',
  ready_by_referent: 'Připraveno obchodním referentem',
  completed: 'Dokončeno',
}

export function getPurchaseStatusLabel(status: string): string {
  return PURCHASE_STATUS_LABELS[status] || status
}

export function getPurchaseStatusClass(status: string): string {
  switch (status) {
    case 'pending_leader':
      return 'status-deferred'
    case 'new':
      return 'status-new'
    case 'deferred':
      return 'status-deferred'
    case 'approved_by_economist':
    case 'approved_by_director':
      return 'status-approved'
    case 'rejected':
    case 'rejected_by_economist':
    case 'rejected_by_director':
    case 'rejected_by_vedouci':
    case 'rejected_by_leader':
    case 'cancelled_by_requester':
    case 'cancelled_by_leader':
    case 'rejected_by_referent':
      return 'status-rejected'
    case 'accepted_by_referent':
      return 'status-accepted'
    case 'ordered_by_referent':
      return 'status-ordered'
    case 'ready_by_referent':
      return 'status-ready'
    case 'completed':
      return 'status-completed'
    default:
      return ''
  }
}

/** Stavy, ve kterých může vedoucí žádost zrušit (po svém schválení). */
export const LEADER_CANCEL_STATUSES = [
  'new',
  'approved_by_economist',
  'deferred',
  'approved_by_director',
  'rejected_by_economist',
  'rejected_by_director',
] as const
